module.exports = __webpack_public_path__ + "static/media/muse_nyarubondo_mwogo_road10.06c4d0a5.jpg";